import { Col, Row } from "reactstrap";
import { BasicForm } from "./basicForm";
import BasicGrid from "./basicGrid";
import { Button } from "antd";
import { ReloadOutlined, SaveOutlined } from "@ant-design/icons";

const BasicDataContent = ({
  onNext,
  currentStep,
  totalSteps,
  // submitted,
  onPrevious,
}) => {
  return (
    <div className="tab-content">
      <BasicForm />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "24px",
          gap: "8px",
        }}
      >
        {currentStep > 1 && (
          <Button color="cyan"
            variant="solid"
            type="primary" onClick={onPrevious}>
            Previous
          </Button>
        )}

        {currentStep < totalSteps && (
          <Button
            color="cyan"
            variant="solid"
            type="primary"
            onClick={onNext}
            // disabled={submitted}
          >
            Next
          </Button>
        )}
      </div>
    </div>
  );
};

export default BasicDataContent;
